import MenuSvg from '../../../assets/menu.svg?react';
import { IconProps } from '../../types/IconProps';

export function Menu({ size = 20, ...props }: IconProps) {
  return <MenuSvg data-testid="menu-icon" width={size} height={size} {...props} />;
}

export default Menu;
